// Click + page-view telemetry, batched to isi_data POST /activity.
// Captures route changes and clicks on [data-track]/buttons/links — labels
// only, never input values. Stays out of the audit trail server-side.
import axios from "axios";
import { ISI_API_URL } from "../config";

const FLUSH_AT = 25;
const FLUSH_INTERVAL_MS = 15000;
const LABEL_MAX = 64;

const sessionId = Math.random().toString(36).slice(2, 14);
let queue = [];
let enabled = false;

function track(type, route, label) {
  if (!enabled) {
    return;
  }
  queue.push({ type, route, label, at_ms: Date.now() });
  if (queue.length >= FLUSH_AT) {
    flush(false);
  }
}

function flush(useKeepalive) {
  if (queue.length === 0) {
    return;
  }
  const events = queue.splice(0, FLUSH_AT * 2);
  const body = JSON.stringify({ session_id: sessionId, events });
  // fetch with keepalive (not sendBeacon) so the request can carry the
  // session cookie with a JSON content type, and survives tab close.
  fetch(ISI_API_URL + "activity", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    keepalive: useKeepalive,
    body,
  }).catch(() => {});
}

function labelForElement(element) {
  const tracked = element.closest("[data-track]");
  if (tracked) {
    return tracked.getAttribute("data-track");
  }
  const clickable = element.closest("button, a, [role='button']");
  if (!clickable) {
    return null;
  }
  const text = (clickable.textContent || "").trim().replace(/\s+/g, " ");
  return text
    ? text.slice(0, LABEL_MAX)
    : clickable.getAttribute("aria-label") || null;
}

export function installTelemetry(router, store) {
  // Hold events until auth completes so unauthenticated 401 noise is avoided
  store.watch(
    (state) => state.authInitialized,
    (initialized) => {
      if (initialized && store.state.user_data.email) {
        enabled = true;
      }
    },
  );

  router.afterEach((to) => {
    track("page_view", to.fullPath, to.name || null);
  });

  document.addEventListener(
    "click",
    (event) => {
      const label = labelForElement(event.target);
      if (label) {
        track("click", router.currentRoute.value.fullPath, label);
      }
    },
    { capture: true, passive: true },
  );

  setInterval(() => flush(false), FLUSH_INTERVAL_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      flush(true);
    }
  });
}
